module.exports = __webpack_public_path__ + "static/fonts/iconfont.422e3469.ttf";